module.exports = __webpack_public_path__ + "img/wRatings-2700x860.143c0a3c.png";